export default "https://cdn-static.gokick.com/assets/ecb6814e4f4fd856ee5e2a82e5f087b2e6d90ad2/images/sleep-tangerine.755ecdb6db700f77bb8084d276871abe.png";